import React from "react";

const Loading = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <div className="animate-spin rounded-full border-t-4 border-red-500 border-opacity-75 h-16 w-16"></div>
    </div>
  );
};

export default Loading;
